import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import {
  GET_ALL_ACTIVE_THERAPIST_KEY,
  GET_ALL_ADMIN_THERAPIST_KEY,
} from '_api/queries/therapist';

export const DELETE_ADMIN_KEY = 'delete-admin';

export const useDeleteAdmin = () => {
  const queryClient = useQueryClient();
  return useApiMutation<{}, { adminId: number }>(
    ({ adminId }) => `/user/${adminId}`,
    'delete',
    {},
    {
      mutationKey: [DELETE_ADMIN_KEY],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_ALL_ADMIN_THERAPIST_KEY] });
        queryClient.invalidateQueries({ queryKey: [GET_ALL_ACTIVE_THERAPIST_KEY] });
      },
    },
  );
};
